import React, { useState, useEffect, useCallback } from 'react'
import { CircularProgress, Divider, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from '@material-ui/core'
import { Page, Header, CustomButton } from 'components'
import { useExameSolicitadoService } from 'hooks/useExameSolicitadoService'
import useRouter from 'utils/useRouter'
import { cutMaxLength } from 'utils/helpers'
import useStyles from './styles'
import { useParams } from 'react-router'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import SaveIcon from '@material-ui/icons/Save'

export const AlterarStatusExame = (props) => {
  const { route } = props
  const classes = useStyles()
  const params = useParams()
  const router = useRouter()
  const exameSolicitadoService = useExameSolicitadoService()
  const [processandoExame, setProcessandoExame] = useState(false)
  const [processandoOperacao, setProcessandoOperacao] = useState(false)
  const [novoStatus, setNovoStatus] = useState('')
  const [reiniciarTexto, setReiniciarTexto] = useState('NAO')
  const [processoSEI, setProcessoSEI] = useState('')

  const fetchExameSolicitado = useCallback(async () => {
    setProcessandoExame(true)
    const exameSolicitado = await exameSolicitadoService.listarExameSolicitadoAsync(params.id)
    setNovoStatus(exameSolicitado?.exReal.status || '')
    setProcessandoExame(false)
  }, [params.id])

  useEffect(() => {
    fetchExameSolicitado()
  }, [fetchExameSolicitado])

  const handleClickConfirmar = useCallback(async () => {
    try {
      setProcessandoOperacao(true)
      await exameSolicitadoService.alterarStatusExame(params.id, novoStatus, reiniciarTexto, processoSEI)
      router.history.push(`/casos/caso/solicitacao/exameSolicitado/detalhar/${params.id}`)
    } catch (err) {
      throw err
    } finally {
      setProcessandoOperacao(false)
    }
  }, [novoStatus, reiniciarTexto, processoSEI, params.id, router.history])

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} pathname={router.location.pathname} router={router} />

      {processandoExame ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <form onSubmit={(e) => e.preventDefault()} style={{ marginTop: '24px' }}>
          <Grid container spacing={3}>
            <Grid item md={12} sm={12} xs={12}>
              <FormControl fullWidth variant="outlined">
                <InputLabel shrink id="status-exame-label">STATUS DO EXAME</InputLabel>
                <Select
                  labelId="status-exame-label"
                  value={novoStatus}
                  onChange={(e) => setNovoStatus(e.target.value)}
                  notched
                  label="STATUS DO EXAME"
                  required
                >
                  {['Pendente', 'Em andamento', 'Finalizado', 'Publicado', 'Cancelado'].map((status) => (
                    <MenuItem key={status} value={status}>{status}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid className={classes.item} item container md={12} sm={12} xs={12}>
              <Grid item md={12} sm={12} xs={12}>
                <Typography variant="body2" style={{ marginBottom: '8px', fontWeight: 600 }}>REINICIAR TEXTO</Typography>
              </Grid>
              <FormControl component="fieldset" fullWidth>
                <RadioGroup aria-label="reiniciar-texto" name="reiniciarTexto" value={reiniciarTexto} onChange={(e) => setReiniciarTexto(e.target.value)} style={{ display: 'flex', flexDirection: 'row' }}>
                  <FormControlLabel value="SIM" control={<Radio color="primary" />} label={<Typography variant="body2">SIM</Typography>} />
                  <FormControlLabel value="NAO" control={<Radio color="primary" />} label={<Typography variant="body2">NÃO</Typography>} />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid className={classes.item} item md={12} sm={12} xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                label="NÚMERO DO PROCESSO SEI DA SOLICITAÇÃO"
                name="processoSEI"
                onChange={(e) => setProcessoSEI(cutMaxLength(e.target.value, 250))}
                value={processoSEI}
                required
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item md={12} sm={12} xs={12}>
              <Divider style={{ margin: '16px 0' }} />
            </Grid>

            <Grid item container justifyContent="space-between" alignItems="center">
              <Grid item>
                <CustomButton variant="outlined" colorType="primary" startIcon={<ArrowBackIcon />} onClick={() => router.history.goBack()}>
                  Voltar
                </CustomButton>
              </Grid>
              <Grid item>
                <CustomButton
                  variant="contained"
                  colorType="secondary"
                  startIcon={<SaveIcon />}
                  isLoading={processandoOperacao}
                  onClick={handleClickConfirmar}
                >
                  Confirmar
                </CustomButton>
              </Grid>
            </Grid>
          </Grid>
        </form>
      )}
    </Page>
  )
}

